import styled from "styled-components";

export const ScMarkup = styled.div`
  display: flex;
  z-index: 100;

  .markup-container {
    flex: 1;
  }

  .space-container {
    height: calc(100vh - 250px);
  }
`;
